// Pro (UI kit 09, web). Only reachable once Pro is on sale
// (ff_pro_launched); before that every Pro feature is free and Pro is never
// mentioned. Payments aren't open yet, so the button says so.
import { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAppData } from '@/app/AppData';
import { usePageTitle } from '@/app/usePageTitle';
import { track } from '@/data/analytics';
import { t } from '@/l10n/strings';
import { Button, LogoMark } from '@/ui/controls';
import { Icon } from '@/ui/Icon';
import { useToast } from '@/ui/Toasts';

export function PaywallPage() {
  const { offersPro, isPro, user } = useAppData();
  const navigate = useNavigate();
  const toast = useToast();
  usePageTitle(t('commonPro'));
  const shown = offersPro || isPro;
  const isGuest = user?.isGuest ?? true;
  useEffect(() => {
    if (shown) track('paywall_viewed', { is_guest: isGuest });
  }, [shown, isGuest]);
  if (!shown) return <Navigate to="/home" replace />;
  const features = ['paywallFeatureTemplates', 'paywallFeatureReminders', 'paywallFeatureRecurring', 'paywallFeatureLinks', 'paywallFeatureQr', 'paywallFeatureNoLine'];
  return (
    <main className="paywall">
      <section className="hero hero--brand paywall__card stack-4">
        <div className="between">
          <LogoMark size={40} />
          <button type="button" className="iconbtn" style={{ color: 'var(--on-surface-strong)' }} aria-label={t('commonClose')} onClick={() => navigate(-1)}>
            <Icon name="x" />
          </button>
        </div>
        <h1 className="display-xl">
          {t('paywallGetPaid')}
          <em style={{ color: 'var(--pro)' }}>{t('paywallGetPaidEnd')}</em>
        </h1>
        <p className="body-lg" style={{ color: 'var(--on-surface-strong-muted)' }}>
          {isPro ? t('paywallYoureOnProThankYou') : t('paywallEverythingInFreePlusThe')}
        </p>
        <ul className="stack-2" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {features.map((key) => (
            <li key={key} className="row">
              <Icon name="check" size={18} style={{ color: 'var(--signal)' }} />
              {t(key)}
            </li>
          ))}
        </ul>
        {!isPro && (
          <Button
            variant="pro"
            size="lg"
            block
            onClick={() => {
              track('subscribe_tapped', { period: 'yearly', result: 'unavailable' });
              toast(user?.isGuest ? t('paywallCreateAFreeAccountFirst') : t('paywallProPaymentsArentOpenYet'));
            }}
          >
            {t('paywallStartTrial', { trialDays: 7 })}
          </Button>
        )}
      </section>
    </main>
  );
}
